import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

type GetActionedByNameParams = {
  currentUserId: string | undefined;
  step: IntakeStatusBaseSteps[keyof IntakeStatusBaseSteps];
};

export const getActionedByName = ({ currentUserId, step }: GetActionedByNameParams) => {
  if (step.currentStatus.actionedBy?.id === currentUserId) {
    return 'You';
  }

  return step.currentStatus.actionedBy?.name ?? null;
};
